export const COURSE_CATEGORIES = [
  "Blockchain & Web3",
  "Artificial Intelligence",
  "Software Development",
  "Data Science",
  "Business & Compliance",
  "Design",
  "Trades & Skilled Work",
  "Human Skills",
  "Other",
]

export const LESSON_TYPES = [
  { value: "video", label: "Video", icon: "PlayCircle" },
  { value: "text", label: "Text Lesson", icon: "FileText" },
  { value: "pdf", label: "PDF Resource", icon: "File" },
  { value: "external", label: "External Link", icon: "Link" },
  { value: "live", label: "Live Session", icon: "Video" },
]

export const createEmptyLesson = (id, type = "video") => ({
  id,
  title: "",
  type,
  order: 0,
  duration: 0,
  videoUrl: "",
  content: "",
  fileUrl: "",
  externalUrl: "",
  sessionDate: "",
  sessionTime: "",
  meetingLink: "",
})

export const createEmptyModule = (id) => ({
  id,
  title: "",
  order: 0,
  lessons: [],
})